/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  RePrepareImportPreviewMutationRequest,
  RePrepareImportPreviewMutationResponse,
  RePrepareImportPreviewPathParams,
  RePrepareImportPreview404,
  RePrepareImportPreview409,
} from '../types/RePrepareImportPreview'

function getRePrepareImportPreviewUrl({
  import_number,
}: {
  import_number: RePrepareImportPreviewPathParams['import_number']
}) {
  const res = {
    method: 'POST',
    url: `/api/v1/importengine/previews/v2/${import_number}/reprepare/` as const,
  }
  return res
}

/**
 * @description Re-run the prepare task on an existing preview, in place.
 * Reuses the same ImportPreview (and its import_number) so the
 * Back -> Map Columns -> Next path never orphans a preview. An optional
 * ``import_data`` body (same shape the create/update endpoints accept,
 * ``{"data": {...}}``) replaces the stored rows with the re-mapped data
 * before re-running ``importengine_create_preview``, which rebuilds the
 * internal columns for the new mapping.
 * @summary Re-run the prepare task on an existing preview, in place
 * {@link /api/v1/importengine/previews/v2/:import_number/reprepare/}
 */
export async function rePrepareImportPreview(
  {
    import_number,
  }: { import_number: RePrepareImportPreviewPathParams['import_number'] },
  data?: RePrepareImportPreviewMutationRequest,
  config: Partial<RequestConfig<RePrepareImportPreviewMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    RePrepareImportPreviewMutationResponse,
    ResponseErrorConfig<RePrepareImportPreview404 | RePrepareImportPreview409>,
    RePrepareImportPreviewMutationRequest
  >({
    method: 'POST',
    url: getRePrepareImportPreviewUrl({ import_number }).url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
